import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import FAQAccordion from "../components/faq_accordion";
import "../styles/products_returns.css";

class ProductsReturnsScreen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { isLoggedIn } = this.props;
    return (
      <>
        <Header isLoggedIn={isLoggedIn} />

        {/* 1. PAGE BANNER */}
        <section className="page-banner py-5">
          <div className="container">
            <h1 className="mb-0">Returns</h1>
          </div>
        </section>

        {/* 2. POLICY CONTENT */}
        <section className="policy-content py-5">
          <div className="container">
            {/* This row/col combo perfectly centers the text block and restricts its width on desktop without breaking mobile */}
            <div className="row justify-content-center">
              <div className="col-12 col-lg-9">
                <div className="policy-text-block mb-5">
                  <h2>What Is XLP Return Policy?</h2>
                  <p>
                    We give you 60 days to try out your XLP purchase to make
                    sure it works for you.
                  </p>
                  <p>Here's what you need to know:</p>
                  <ul className="policy-list">
                    <li>
                      You can return within 60 days of an online order delivery
                      or XLP store purchase.
                    </li>
                    <li>Proof of purchase is required to return.</li>
                    <li>
                      Items purchased at XLP Clearance stores cannot be
                      returned, and XLP Clearance stores do not accept returns
                      of any kind.
                    </li>
                    <li>
                      Returns are free for XLP Members. So go ahead, shop with
                      confidence and enjoy your 60-day trial.
                    </li>
                  </ul>
                </div>

                {/* 3. FAQ SECTION */}
                <div className="faq-section mb-5">
                  <h2 className="mb-4">FAQs</h2>
                  <FAQAccordion />
                </div>

                {/* 4. PRICE EXCHANGES */}
                <div className="price-exchanges-section">
                  <h2 className="mb-3">Price Exchanges</h2>
                  <p>
                    We know how important it is to feel confident in your
                    purchase, which is why we offer a price adjustment policy
                    for eligible products. If the price of an item you purchased
                    drops within seven days of your order date, you can request
                    a price exchange to receive a refund for the difference. To
                    take advantage of this benefit, simply reach out to our
                    customer service team with your order details, and we will
                    verify the eligibility of your request. Price exchanges
                    apply only to identical items in the same size, color, and
                    style that remain in stock at the time of the request. This
                    policy ensures you always get the best value on your
                    purchases without worrying about missing out on discounts or
                    promotions. Keep in mind that items purchased during special
                    clearance events may not qualify for price adjustments.
                  </p>

                  <hr className="policy-divider my-5" />

                  {/* 5. CONTACT CARDS (Fully Responsive Bootstrap Grid) */}
                  {/* 1 col on mobile (col-12), 3 cols on tablets and up (col-md-4) */}
                  <div className="row g-4">
                    <div className="col-12 col-md-4">
                      <div className="contact-card h-100 p-4 shadow-sm">
                        <h4>Work days</h4>
                        <p>
                          Monday - Friday: 9am-9pm ET
                          <br />
                          Saturday & Sunday: 10am-7pm ET
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-md-4">
                      <div className="contact-card h-100 p-4 shadow-sm">
                        <h4>Email</h4>
                        <p>
                          We strive to answer emails within 48 hours
                          <br />
                          <a href="mailto:info@mail.com">info@mail.com</a>
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-md-4">
                      <div className="contact-card h-100 p-4 shadow-sm">
                        <h4>Phone</h4>
                        <p>
                          Online Inquiries | 123-456-7890
                          <br />
                          Store Inquiries | 123-456-7890
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

export default ProductsReturnsScreen;
